import React, { useContext } from 'react';
import { IFilledLocalAnalys } from '../../../EkonomiskAnalysMain/EkonomiskAnalysMain';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import EDCheckbox from '../../../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import { ISelectedAnalys } from '../../../../EkonomiskAnalysPage';
import { ISelectChoice } from '../../../../../../../../../BaseComponents/Selects/SelectCommons';
import { IColumn } from '../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import {
  EkonomiskAnalysContext,
  IAnalysResultColumn,
} from '../../../Context/EkonomiskAnalysContext';
import { EkonomiskAnalysSummeringsReceptQuery_db_EKDetaljeringsniva_All } from '../../../EkonomiskAnalysPrintPDFModal/Querys/EkonomiskAnalysSummeringsReceptQuery/_QueryTypes/EkonomiskAnalysSummeringsReceptQuery';
import { EDAutoCompleteEdit } from '../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import EDBox from '../../../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  analysSettings: IFilledLocalAnalys;
  selectedAnalys: ISelectedAnalys;
  includeDetails: boolean;
  setIncludeDetails: (newIncludeDetails: boolean) => void;
  detailColumnIndex: number;
  setDetailColumnIndex: (newDetailColumnIndex: number) => void;
  radbaserad: boolean;
  lopsaldoDetaljrad?: boolean;
  setLopsaldoDetaljrad?: (checked: boolean) => void;
  sortDateColumnAscending?: boolean;
  setSortDateColumnAscending?: (checked: boolean) => void;
  summeringsRecept?: EkonomiskAnalysSummeringsReceptQuery_db_EKDetaljeringsniva_All[];
  selectedSummeringsRecept?: string;
  setSelectedSummeringsRecept?: (recept: string) => void;
}

export const firstVisibleColIndex = (columns: IColumn[]): number =>
  columns.findIndex(column => !column.data.HIDE_COLUMN && !column.data.INTERN);

const hasDetails = (column: IAnalysResultColumn): boolean => {
  const fieldCode = column.fieldCode;

  if (!fieldCode) {
    return false;
  } else if (
    fieldCode === 'DIFFPERVARDEBUDGET' ||
    fieldCode === 'PROCENTPERVARDEBUDGET' ||
    fieldCode === 'DIFFPERINGVARDEBUDGET' ||
    fieldCode === 'PROCENTPERINGVARDEBUDGET' ||
    fieldCode === 'DIFFPERUTGVARDEBUDGET' ||
    fieldCode === 'PROCENTPERUTGVARDEBUDGET' ||
    fieldCode === 'DIFFARETSVARDEBUDGET' ||
    fieldCode === 'PROCENTARETSVARDEBUDGET'
  ) {
    return false;
  } else {
    return true;
  }
};

const columnsToSelectItems = (
  columns: IAnalysResultColumn[]
): Array<ISelectChoice<number>> =>
  columns.map(column => ({
    header: column.name,
    value: column.index,
  }));

const summeringsReceptToSelectItems = (
  recept:
    | EkonomiskAnalysSummeringsReceptQuery_db_EKDetaljeringsniva_All[]
    | undefined
    | null
): Array<ISelectChoice<string>> | null => {
  if (!recept) {
    return null;
  }
  return recept.map(r => ({ header: r.BENAMNING, value: r.id }));
};

const useStyles = makeStyles()((theme: Theme) => ({
  detailsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  sumReceptContainer: {
    justifyContent: 'flex-end',
  },
  selectContainer: {
    width: '100%',
    minWidth: '260px',
  },
}));

const radbaseradDisabledReason =
  'Inkludera detaljer ej tillgänglig för radbaserade analyser';

// const ejRelevantaDisabledReason = 'Ej aktuell då detaljer ej visas';

/**
 * Ett val av kolumner i en export dialog
 */
const EkonomiskAnalysExportDetailsSettings: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes, cx } = useStyles();
  const ekonomiskAnalysContext = useContext(EkonomiskAnalysContext);

  const columns = ekonomiskAnalysContext.analysResultColumns;

  const disableDetailSettings = props.radbaserad || !props.includeDetails;

  // Start för eventuellt framtida bruk
  // if (not Field[i].DisableField) and (Field[i].Typ = Saldotyp) and (Field[i].Code = 'PERINGVARDE') and

  // (Field[fi].IntervalType = Field[i].IntervalType) and (((Field[i].IntervalType = 1) and (Field[fi].FromBokfdatum = IncDay(Field[i].TomBokfdatum, 1)))
  // or
  // ((Field[i].IntervalType = 0) and (Field[fi].FromBokfar = Field[i].FromBokfar) and (Field[fi].FromBokfper = (Field[i].TomBokfper + 1)))) then

  // const hasIngVarde = props.analysSettings.columns.find(column => {
  //   // const columnDate = new Date(column.data.TOM_PER ?? '');
  //   // columnDate.setDate(columnDate.getDate() + 1);

  //   const selectedCol = props.analysSettings.columns[props.detailColumnIndex];
  //   return (
  //     column.data.FALT_TYP === 0 &&
  //     column.data.FALTKOD === 'PERINGVARDE' &&
  //     selectedCol.data.FALTKOD === 'PERVARDE' &&
  //     column.data.INTERVALL_TYP === selectedCol.data.INTERVALL_TYP &&
  //     (selectedCol.data.INTERVALL_TYP === 1 ||
  //       (selectedCol.data.FROM_PER_RELATIV && column.data.TOM_PER_RELATIV))
  //     // ((selectedCol.data.INTERVALL_TYP === 1 &&
  //     //   selectedCol.data.FROM_PER != null &&
  //     //   column.data.TOM_PER != null &&
  //     //   new Date(selectedCol.data.FROM_PER) === columnDate) ||
  //     //   (selectedCol.data.INTERVALL_TYP === 0 &&
  //     //     selectedCol.data.FROM_PER != null &&
  //     //     column.data.TOM_PER != null &&
  //     //     new Date(selectedCol.data.FROM_PER) === columnDate))
  //   );
  // });

  const detailSelectItems = columnsToSelectItems(columns.filter(hasDetails));
  const summeringsReceptSelectItems = summeringsReceptToSelectItems(
    props.summeringsRecept
  );

  return (
    <>
      <EDBox display="flex" alignItems="center" marginBottom={2}>
        <EDCheckbox
          label="Inkludera detaljer"
          checked={props.includeDetails}
          onCheck={props.setIncludeDetails}
          checkboxSpacing={{ paddingY: 0.5 }}
          mt={3}
          marginRight={2}
          flexShrink={0}
          disabled={props.radbaserad}
          disabledReason={radbaseradDisabledReason}
        />
        <div className={classes.selectContainer}>
          <EDAutoCompleteEdit
            label="Välj kolumn"
            notSelectedLabel="Välj kolumn"
              onChange={(a: ISelectChoice<number> | null) =>
              props.setDetailColumnIndex(a?.value ?? -1)
            }
            options={detailSelectItems}
            getOptionLabel={a => a.header}
            disabled={props.radbaserad || !props.includeDetails}
            fullWidth
            value={
              props.radbaserad
                ? undefined
                : detailSelectItems[props.detailColumnIndex]
            }
          />
        </div>
      </EDBox>
      <div className={cx(classes.detailsContainer, classes.sumReceptContainer)}>
        {/* <Checkbox
        label="Sortera i stigande datumordning"
        checked={props.sortDateColumnAscending}
        onCheck={props.setSortDateColumnAscending}
        disabled={disableDetailSettings}
        disabledReason={
          props.radbaserad
            ? radbaseradDisabledReason
            : props.includeDetails
            ? undefined
            : ejRelevantaDisabledReason
        }
      /> */}
        {props.setSelectedSummeringsRecept && summeringsReceptSelectItems && (
          <div className={classes.selectContainer}>
            <EDAutoCompleteEdit
              label="Välj summeringsrecept"
              notSelectedLabel="Välj summeringsrecept"
              onChange={(a: ISelectChoice<string> | null) =>
                props.setSelectedSummeringsRecept?.(a?.value ?? '')
              }
              options={summeringsReceptSelectItems}
              getOptionLabel={a => a.header}
              disabled={disableDetailSettings}
              fullWidth
              value={
                props.radbaserad
                  ? undefined
                  : summeringsReceptSelectItems.find(
                      a => a.value === props.selectedSummeringsRecept
                    )
              }
            />
          </div>
        )}
        {/* {props.analysSettings.lopsaldoDetaljrad && (
        <Checkbox
          label="Ackumulerat saldo"
          checked={props.lopsaldoDetaljrad}
          onCheck={props.setLopsaldoDetaljrad}
          disabled={disableDetailSettings}
          disabledReason={
            props.radbaserad
              ? radbaseradDisabledReason
              : props.includeDetails
              ? undefined
              : ejRelevantaDisabledReason
          }
        />
      )} */}
      </div>
    </>
  );
};

export default EkonomiskAnalysExportDetailsSettings;
